module.exports = __webpack_public_path__ + "img/DAO.7e9ce8ba.svg";